import { createSelector } from 'reselect'

const getFilteredEntities = (state, entityKey, filterField, filterId) => {
  const filtered = {}
  const entities = state.entities[entityKey]
  const keys = Object.keys(entities)

  keys.forEach((key) => {
    const entity = entities[key]
    if (entity[filterField] && entity[filterField] === filterId){
      filtered[key] = entity
    }
  })

  return filtered
}

const filteredObjectsSelector = createSelector([getFilteredEntities], entities => entities)

export default filteredObjectsSelector
